// import { useState } from 'react';
// import api from '../api';

// const PayrollUpload = () => {
//   const [file, setFile] = useState(null);
//   const [result, setResult] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!file) {
//       alert('Select an Excel file first');
//       return;
//     }
//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append('file', file);
//       const res = await api.post('/payroll/upload', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       setResult(res.data);
//     } catch (err) {
//       console.error(err);
//       alert('Error uploading Excel');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="card">
//       <div className="card-header">
//         <h2>Upload Payroll Excel</h2>
//       </div>

//       <form onSubmit={handleSubmit}>
//         <div className="input-row">
//           <div className="input-group">
//             <label>Select Excel file</label>
//             <input
//               type="file"
//               accept=".xlsx,.xls"
//               onChange={(e) => setFile(e.target.files[0] || null)}
//             />
//           </div>
//         </div>
//         <button className="btn btn-primary" type="submit" disabled={loading}>
//           {loading ? 'Processing...' : 'Upload & Generate Payslips'}
//         </button>
//       </form>

//       {result && (
//         <div className="mt-3">
//           <p>Upload completed.</p>
//           {result.errors && result.errors.length > 0 ? (
//             <>
//               <p className="text-muted">
//                 Some rows had issues:
//               </p>
//               <ul>
//                 {result.errors.map((e, idx) => (
//                   <li key={idx}>
//                     <strong>{e.emp_code}</strong>: {e.error}
//                   </li>
//                 ))}
//               </ul>
//             </>
//           ) : (
//             <p className="text-muted">All rows processed successfully.</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default PayrollUpload;






import { useState } from "react";
import api from "../api";

const PayrollUpload = () => {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Select an Excel file first");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post("/payroll/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(res.data);
    } catch (err) {
      console.error(err);
      alert("Error uploading Excel");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const f = e.target.files?.[0];
    setFile(f || null);
    setResult(null);
  };

  return (
    <div className="payroll-shell">
      {/* Header */}
      <div className="payroll-header">
        <div>
          <h1 className="payroll-title">Payroll Upload</h1>
          <p className="payroll-subtitle">
            Import monthly payroll details from the standard Excel template.
          </p>
        </div>
      </div>

      {/* Card */}
      <div className="payroll-card">
        <div style={{ marginBottom: 12 }}>
          <a
            className="btn-secondary"
            href="/payroll_upload_sample.xlsx"
            download
            style={{ textDecoration: "none" }}
          >
            Download Sample Format
          </a>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="payroll-form-row">
            <label htmlFor="payroll-file" className="upload-dropzone">
              <div className="upload-icon">📄</div>
              <div>
                <div className="upload-title">
                  {file ? "Change payroll Excel file" : "Select or drop Excel file"}
                </div>
                <div className="upload-subtitle">
                  Accepted formats: <strong>.xlsx</strong>, <strong>.xls</strong>.  
                  Make sure Emp Code, month, and salary fields match the template.
                </div>
              </div>
              <input
                id="payroll-file"
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
              />
            </label>

            {file && (
              <div className="upload-file-meta">
                <span className="upload-file-label">Selected file:</span>
                <span className="upload-file-name">{file.name}</span>
              </div>
            )}
          </div>

          <div className="payroll-actions">
            <button
              className="btn-primary-large"
              type="submit"
              disabled={loading}
            >
              {loading ? "Processing…" : "Upload & Process Payroll"}
            </button>
          </div>
        </form>

        {/* Result / summary */}
        {result && (
          <div className="payroll-result">
            <div className="payroll-result-header">
              <h3>Upload Summary</h3>
              <span className="payroll-result-pill">
                {result.successCount ?? result.success ?? 0} successful
                {typeof result.total === "number"
                  ? ` of ${result.total} rows`
                  : ""}
              </span>
            </div>

            {result.errors && result.errors.length > 0 ? (
              <>
                <p className="payroll-result-text">
                  Some rows could not be processed. Please review and correct
                  them in the Excel file.
                </p>
                <div className="payroll-errors-box">
                  <table className="payroll-errors-table">
                    <thead>
                      <tr>
                        <th>Emp Code</th>
                        <th>Issue</th>
                      </tr>
                    </thead>
                    <tbody>
                      {result.errors.map((e, idx) => (
                        <tr key={idx}>
                          <td>{e.emp_code || "-"}</td>
                          <td>{e.error}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <p className="payroll-result-text success">
                ✅ All rows processed successfully. Payslips are ready under the
                “Payslips” tab.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollUpload;
